import { Box, Chip, Stack, SxProps, Typography } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import type { MoneyV2 } from "@shopify/hydrogen-react/storefront-api-types";
import React from "react";
import { formatCurrency } from "../../shared/utils";

type MoneyDisplayProps = {
    money: Queries.ShopifyMoneyV2 | MoneyV2
    nonDiscounted?: Queries.ShopifyMoneyV2 | MoneyV2
    direction?: 'row' | 'column' | 'column-reverse' | 'row-reverse'
    showSavePill?: boolean
    savePillAsValue?: boolean
    compactOnMobile?: boolean
    showCurrencyCode?: boolean
    invertSaveDirection?: boolean
    totalSxProps?: SxProps
    chipPrefix?: string
    valueSuffix?: string
    quantity?: number
    priceDirection?: 'row' | 'column' | 'column-reverse' | 'row-reverse'
}

export const MoneyDisplay = ({ priceDirection, money, nonDiscounted, quantity, direction = 'column', showSavePill, savePillAsValue, invertSaveDirection, compactOnMobile, totalSxProps, valueSuffix, showCurrencyCode, chipPrefix = 'Sale - Save ' }: MoneyDisplayProps) => {
    const parsed = money as MoneyV2;
    const theme = useTheme()
    const qty = quantity || 1;
    const parsedNonDiscounted = nonDiscounted ? { currencyCode: nonDiscounted.currencyCode, amount: nonDiscounted.amount } as MoneyV2 : null;

    const discountValue = parsedNonDiscounted ? (parseFloat(parsedNonDiscounted.amount || '0')) - (parseFloat(parsed?.amount || '0')) : 0;
    const discountPercent = nonDiscounted ? (discountValue / (parseFloat(parsedNonDiscounted.amount))) * 100 : 0;

    const hideOnMobile = { display: compactOnMobile ? { xs: 'none', sm: 'none', md: 'initial' } : undefined }

    const totalParsed = {
        ...parsed,
        amount: (parseFloat(parsed?.amount || '0')).toString()
    }
    const discountValueParsed = {
        ...parsed,
        amount: discountValue.toString()
    }

    return (
        <Stack direction={priceDirection ? priceDirection : direction} gap={direction === 'column' ? 1 : 3}>
            <Stack gap={direction === 'column' ? 1 : 3} direction={direction === 'column' && invertSaveDirection ? 'column-reverse' : (direction === 'row' && invertSaveDirection ? 'row-reverse' : direction)}>
                <Box>
                    <Typography component="div" sx={{ ...totalSxProps }}>{formatCurrency(totalParsed, undefined, qty, showCurrencyCode)}{valueSuffix}</Typography>
                </Box>

                {parsedNonDiscounted && discountValue ? (
                    <Box sx={hideOnMobile}>
                        <Typography component="div" sx={{ textDecoration: 'line-through', color: theme.palette.text.secondary }}>{formatCurrency(parsedNonDiscounted, undefined, qty, showCurrencyCode)}</Typography>
                    </Box>
                ) : <></>
                }
            </Stack>

            {parsedNonDiscounted && showSavePill && discountPercent && !savePillAsValue && discountValue ? <Chip size='small' color='success' label={`${chipPrefix}${discountPercent.toFixed(0)}%`} /> : <></>}
            {parsedNonDiscounted && showSavePill && discountPercent && savePillAsValue && discountValue ? <Chip size='small' color='success' label={`Save ${formatCurrency(discountValueParsed, true, qty)}`} /> : <></>}
        </Stack>
    )
}